var exports = {
  "s": "x31de4314--fff4f3--checkbox-group",
};

module.exports = exports;
